module.exports = __webpack_public_path__ + "static/diagnosis-42a299625b22342d82fc8438a4637e7d.png";